import { render, staticRenderFns } from "./ProductEditorDeliveryStatistics.vue?vue&type=template&id=4c502767&"
import script from "./ProductEditorDeliveryStatistics.vue?vue&type=script&lang=js&"
export * from "./ProductEditorDeliveryStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports